import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../../../customerFullInfoState/customerFullInfoContext';

const Tips3Field: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	if (customerForFullInfo?.defaultTips[3]) {
		return (
			<FullInfoField
				label={customerForFullInfo.defaultTips[3].isDefault ? 'tips3DefaultLabel' : 'tips3Label'}
				value={customerForFullInfo.defaultTips[3].value}
			/>
		);
	}
	return <FullInfoField label="tips3Label" value={null} />;
};

export default Tips3Field;
